import {
  JobLogDetails,
  NonScheduledJobsHistory,
  ScheduledJobLogForJob,
  ScheduledJobsHistory,
  ScheduledJobsHistorySummary,
} from '@x/types';
import { ApiMutationConfig, ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type GetHistoryParams = {
  PageNumber: number;
  PageSize: number;
  Ascending: boolean;
  OrderBy: string;
  OrganizationId?: number;
};

type GetScheduledJobsHistoryConfig = ApiQueryConfig<
  ScheduledJobsHistory,
  unknown,
  GetHistoryParams
>;

export const getScheduledJobsHistory =
  createApiEndpoint<GetScheduledJobsHistoryConfig>({
    url: `${URLS.app}/api/ServiceSequenceJobLogs`,
    method: 'GET',
  });

type GetNonScheduledJobsHistoryConfig = ApiQueryConfig<
  NonScheduledJobsHistory,
  unknown,
  GetHistoryParams
>;

export const getScheduledJobsHistorySummary =
  createApiEndpoint<GetScheduledJobsHistorySummaryConfig>({
    url: `${URLS.app}/api/ServiceSequenceJobLogs/Summary`,
    method: 'GET',
  });

type GetScheduledJobsHistorySummaryConfig = ApiQueryConfig<
  ScheduledJobsHistorySummary,
  unknown,
  GetHistoryParams
>;

export const getScheduledJobsHistorySummaryForJob =
  createApiEndpoint<GetScheduledJobsHistorySummaryForJobConfig>({
    url: `${URLS.app}/api/ServiceSequenceJobLogs/Summary/$jobId`,
    method: 'GET',
  });

type GetScheduledJobsHistorySummaryForJobConfig = ApiQueryConfig<
  ScheduledJobLogForJob,
  JobPathParams
>;

export const getNonScheduledJobsHistory =
  createApiEndpoint<GetNonScheduledJobsHistoryConfig>({
    url: `${URLS.app}/api/ServiceRunnerJobLogs/NoSequenceSchedule`,
    method: 'GET',
  });

type JobPathParams = { $jobId: string };
type GetJobDetailsConfig = ApiQueryConfig<JobLogDetails[], JobPathParams>;
export const getJobDetails = createApiEndpoint<GetJobDetailsConfig>({
  url: `${URLS.app}/api/Logs/Job/$jobId`,
  method: 'GET',
});

type GetLogFilePathParams = { $fileId: number };
type GetLogFileConfig = ApiMutationConfig<unknown, GetLogFilePathParams, Blob>;
export const getLogFile = createApiEndpoint<GetLogFileConfig>({
  url: `${URLS.app}/api/UploadFiles/$fileId`,
  method: 'GET',
  responseType: 'blob',
});

type CancelJobConfig = ApiMutationConfig<unknown, JobPathParams>;
export const cancelJob = createApiEndpoint<CancelJobConfig>({
  url: `${URLS.app}/api/ServiceSequenceJobLogs/ByJobId/$jobId/Cancel`,
  method: 'POST',
});
